// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__aFm3t","label":"styles_label__0_6qh","icon":"styles_icon__Q5pJd"};